















































































































import { Component, Vue } from "vue-property-decorator";
import { Library, LibraryTerm } from "@/interfaces";
import { deleteLibraryTerm, getLibrary } from "@/services";

import NewLibraryTermDialog from "@/components/NewLibraryTermDialog.vue";
import { notifyError, notifySuccess } from "@/common/notify";

@Component
export default class LibraryManagement extends Vue {
  librarySlug = "";
  library: Library | null = null;
  loading = false;
  filteredData: LibraryTerm[] = [];

  searchText = "";

  async mounted() {
    try {
      this.loading = true;
      this.librarySlug = this.$route.params.slug;
      this.library = await getLibrary(this.librarySlug);
      this.filteredData = this.library.terms;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  dataSearchSubmit() {
    if (this.library) {
      if (this.searchText.trim() !== "") {
        this.filteredData = this.library.terms.filter(term =>
          term.name.toLowerCase().includes(this.searchText.toLowerCase()),
        );
      } else {
        this.filteredData = this.library.terms;
      }
    }
  }

  openLibraryPage(row: LibraryTerm) {
    this.$router.push(`library-management/${row.name}`).catch(error => console.log(error));
  }

  onDeleteTerm(row: LibraryTerm) {
    this.$q
      .dialog({
        title: "Attenzione",
        message: `Sei sicuro di volere eliminare il termine <strong>${row.name}</strong>?`,
        html: true,
        cancel: true,
      })
      .onOk(() => {
        this.deleteTermAction(row);
      });
  }

  async deleteTermAction(element: LibraryTerm) {
    try {
      await deleteLibraryTerm(element.id);
      if (this.library) {
        const terms = [...this.library.terms].filter(el => el.id !== element.id);
        this.$set(this.library, "terms", terms);
        this.filteredData = terms;
        this.searchText = "";
      }
      notifySuccess("Termine rimosso con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile eliminare il termine!");
    }
  }

  openAddDialog() {
    this.$q
      .dialog({
        component: NewLibraryTermDialog,
        parent: this,
        title: "Aggiungi Termine",
        librarySlug: this.librarySlug,
        parents: this.library && this.library.parents ? this.library.parents : [],
      })
      .onOk((newTerm: LibraryTerm) => {
        if (this.library) {
          const terms = [...this.library.terms];
          terms.push(newTerm);
          this.$set(this.library, "terms", terms);
          this.filteredData = terms;
          this.searchText = "";
        }
      });
  }

  openEditDialog(term: LibraryTerm) {
    this.$q
      .dialog({
        component: NewLibraryTermDialog,
        parent: this,
        title: "Modifica Termine",
        librarySlug: this.librarySlug,
        parents: this.library && this.library.parents ? this.library.parents : [],
        term,
      })
      .onOk((newTerm: LibraryTerm) => {
        if (this.library) {
          const terms = [...this.library.terms];
          const termIndex = terms.findIndex(el => el.id === newTerm.id);

          if (termIndex !== -1) {
            const oldTerm = terms[termIndex];
            this.$set(terms, termIndex, {
              ...oldTerm,
              ...newTerm,
            });
            this.$set(this.library, "terms", terms);
            this.filteredData = terms;
            this.searchText = "";
          }
        }
      });
  }

  get canEdit() {
    return this.library && this.library.can.edit === 1;
  }

  get canAdd() {
    return this.library && this.library.can.add === 1;
  }

  get canDelete() {
    return this.library && this.library.can.delete === 1;
  }

  get columns() {
    return [
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
        sortable: true,
      },
      {
        name: "count",
        label: "Conteggio",
        field: "count",
        align: "left",
        sortable: true,
      },
      { name: "edit", align: "center" },
      { name: "delete", align: "center" },
    ];
  }
}
